/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
// material
import SectionCard from 'material/expandablesection/sectioncard/sectioncard';
import SectionGroup from 'material/expandablesection/sectiongroup/sectiongroup';
import SectionGroupDescription from 'material/expandablesection/sectiongroupdescription/sectiongroupdescription'
import { Group, Control } from "@insticator/insticator-ui";
// actions
import { updateGeneralSettings } from 'state/actions/commentingState/configurationStatus';

const FontSettings = (props) => {

    // action dispatch
    const dispatch = useDispatch();
    const updateGeneralState = (prop, val) => dispatch(updateGeneralSettings(prop, val));

    // redux state
    const fontSize = useSelector(({ commentingState }) => commentingState.configStatus.general.fontSize);
    const weight = useSelector(( {commentingState }) => commentingState.configStatus.general.weight);

  return(
      <SectionCard>
          <SectionGroup>
              <SectionGroupDescription
                  title='Font configurations'
                  description='Font settings for better accessibility.'
              />
          </SectionGroup>

          <SectionGroup secondary>
              <SectionGroupDescription title='Font size' />
              <Group name={'controls'} >
                  <Control text={'Regular'} value={15} handleSelect={val => updateGeneralState('fontSize', val)} selected={fontSize === 15} variant={'secondary'} addCheckWhenSelected={true}/>
                  <Control text={'Comfortable'} value={16} handleSelect={val => updateGeneralState('fontSize', val)} selected={fontSize === 16} variant={'secondary'} addCheckWhenSelected={true}/>
                  <Control text={'Accessible'} value={17} handleSelect={val => updateGeneralState('fontSize', val)} selected={fontSize === 17} variant={'secondary'} addCheckWhenSelected={true}/>
              </Group>
          </SectionGroup>

          <SectionGroup secondary>
              <SectionGroupDescription title='Font weight' />
              <Group name={'controls'} >
                  <Control text={'Regular'} value={400} handleSelect={val => updateGeneralState('weight', val)} selected={weight === 400} variant={'secondary'} addCheckWhenSelected={true}/>
                  <Control text={'Medium'} value={500} handleSelect={val => updateGeneralState('weight', val)} selected={weight === 500} variant={'secondary'} addCheckWhenSelected={true}/>
              </Group>
          </SectionGroup>
      </SectionCard>
)
};

export default FontSettings
